<template>
	<div class="scenariooffice">
		<Loading msg="loading" v-if="!isload" />
		<div class="guide_inner" v-else>
      		<img @click="$parent.goBack()"
				v-lazy="'https://static.inertiabiotech.com/uniskin/reportv3/images/gene_test_back.png'"
				class="back_btn lazy"
				alt="" />
                <div class="inner_up">
                    <h1 class="guide_title">办公室人群如何护肤</h1>
                    <ul class="detail_menu">
                        <li class="menu_item" :class="focused_idx == 0 ? 'now' : ''" @click="($parent.trackLog((actParams = { query: $route.query, pageid:617 }),{is_access:true,reportEvent_page_id:617,reportEvent_page_name:'办公室人群 - 空调和暖气',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'场景护肤',reportEvent_third_module:'办公室人群'}));changeFocusedTab(0);" ref="focused_item_0">空调和暖气</li>
                        <li class="menu_item" :class="focused_idx == 1 ? 'now' : ''" @click="($parent.trackLog((actParams = { query: $route.query, pageid:618 }),{is_access:true,reportEvent_page_id:618,reportEvent_page_name:'办公室人群 - 工作压力',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'场景护肤',reportEvent_third_module:'办公室人群'}));changeFocusedTab(1);" ref="focused_item_1">工作压力</li>
                        <li class="menu_item" :class="focused_idx == 2 ? 'now' : ''" @click="($parent.trackLog((actParams = { query: $route.query, pageid:619 }),{is_access:true,reportEvent_page_id:619,reportEvent_page_name:'办公室人群 - 更多建议',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'场景护肤',reportEvent_third_module:'办公室人群'}));changeFocusedTab(2);" ref="focused_item_2">更多建议</li>
                        <span class="bg_div" :style="'width:' + focused_width + 'px;left:' + focused_left + 'px'"></span>
                    </ul>
                </div>

                <!-- 空调和暖气 -->
                <div class="inner_down inner_down_first" v-if="focused_idx ==0">
                  <p class="inner_down_sub_text">因为空调和暖气的存在，办公室等室内环境里的空气湿度通常较低，皮肤角质细胞中的水分容易被空气“吸走”，脸颊容易干燥、泛红，冬天尤甚。</p>
                  <div class="office_focus_part">
                    <div class="office_focus_title">针对问题</div>
                    <div class="office_focus"><span>干燥</span></div>
                  </div>
                  <div class="office_skincare_title">护肤建议</div>
                  <div class="office_skincare_sug_title">补水保湿</div>
                  <p class="office_skincare_sug_text">最好的方式是开加湿器，通过提高周围环境的空气湿度，来减少皮肤水分的流失。也可以用喷雾+乳液的组合，为皮肤缓解干燥感，提高保湿锁水的能力。 </p>
                  <div class="office_skincare_sug_detail">
                    <p class="office_skincare_sug_detail_item">使用方法</p>
                    <p class="office_skincare_sug_detail_item">step1. 用吸油纸或纸巾轻轻吸去脸上的油</p>
                    <p class="office_skincare_sug_detail_item">step2. 距离脸部约10cm，使用喷雾均匀补水</p>
                    <p class="office_skincare_sug_detail_item">step3. 静待约半分钟后用纸巾吸去脸上的水珠</p>
                    <p class="office_skincare_sug_detail_item">step4. 涂抹保湿乳液</p>
                  </div>
                  <div class="office_rec_title">产品推荐</div>
                  <ul class="office_filter_menu">
                    <li class="office_filter_menu_item" :class="office_pro_type == 'water_maintain_spray' ? 'now' : ''" @click="($parent.trackLog((actParams = { query: $route.query, pageid:620 }),{is_access:true,reportEvent_page_id:620,reportEvent_page_name:'办公室人群 - 空调和暖气 - 产品列表',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'场景护肤',reportEvent_third_module:'办公室人群'}));office_pro_type='water_maintain_spray'">喷雾</li>
                    <li class="office_filter_menu_item" :class="office_pro_type == 'water_maintain_lotion' ? 'now' : ''" @click="($parent.trackLog((actParams = { query: $route.query, pageid:620 }),{is_access:true,reportEvent_page_id:620,reportEvent_page_name:'办公室人群 - 空调和暖气 - 产品列表',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'场景护肤',reportEvent_third_module:'办公室人群'}));office_pro_type='water_maintain_lotion'">乳液</li>
                  </ul>
                   
                   <!-- 推荐产品 -->
                  <ul class="office_rec_pro_list">
                      <li class="office_rec_pro" v-for="(rec_pro,rec_idx) in office_pro_list[office_pro_type]" :key="rec_idx">
                          <div class="office_rec_pro_check_btn" v-if="rec_pro.go_mall" @click="$parent.goMallDetail(rec_pro.pro_id)">
                              <span class="office_rec_pro_check_text">去购买</span>
                              <img src="../assets/images/arrow_right_d.svg" class="office_rec_pro_check_icon" alt="">
                          </div>         
                          <img v-lazy="rec_pro.url" :key="rec_pro.url" class="pro_pic" alt="">
                          <div class="pro_detail">
                              <div class="pro_name">{{rec_pro.name}}</div>
                              <div class="pro_ing" v-if="rec_pro.effect.length>0"><span>功效:</span><span class="ing_item">{{rec_pro.effect}}</span></div>
                              <div class="pro_price">参考价格:{{rec_pro.price}}</div>
                          </div>
                      </li>
                      <!-- <li class="office_rec_pro">
                          <div class="office_rec_pro_check_btn">
                              <span class="office_rec_pro_check_text">去购买</span>
                              <img src="../assets/images/arrow_right_d.svg" class="office_rec_pro_check_icon" alt="">
                          </div>         
                          <img src="../assets/images/Lotion.png" class="pro_pic" alt="">
                          <div class="pro_detail">
                              <div class="pro_name">洗颜专科</div>
                              <div class="pro_ing"><span>功效:</span><span class="ing_item">清洁</span></div>
                              <div class="pro_price">参考价格:180元/100g</div>
                          </div>
                      </li> -->
                  </ul>               

                </div>
                <!-- 工作压力 -->
                <div class="inner_down inner_down_second" v-if="focused_idx == 1">
                    <div class="inner_down_text">工作当中遇到的压力和负面情绪会激发身体的应激反应，神经系统和内分泌系统被调动，引起一系列激素的释放。 <br>皮肤结构中的皮脂腺、角质细胞、黑色素细胞等也会参与这一过程，在体内激素的作用下，皮肤会出现各种问题，例如油脂分泌过量、炎症反应加剧、屏障修复能力下降等。 </div>
                    <div class="office_focus_part">
                      <div class="office_focus_title">针对问题</div>
                      <div class="office_focus"><span>痘痘</span><span>屏障变差</span><span>炎症</span></div>
                    </div>
                    <div class="office_skincare_sug_title">护肤建议</div>
                    <!-- 清洁控油 -->
                    <div class="office_item">
                        <div class="office_item_title"><span class="office_item_title_text">控油</span></div>
                        <p class="office_item_text">出油较多的人建议适当使用控油护肤品，以减少皮肤油脂的分泌，避免在忙碌的工作中变得油汪汪，带来脱妆、长痘等困扰。如果长痘很严重一定要就医。</p>
                        <!-- <div class="office_item_summary">清洁力需求:一般</div>
                        <div class="office_item_summary">清洁产品种类推荐:卸妆水/啫喱,卸妆乳,洗卸合一洗面奶</div> -->
                        <div class="office_item_check_btn"><span @click="($parent.trackLog((actParams = { query: $route.query, pageid:621 }),{is_access:true,reportEvent_page_id:621,reportEvent_page_name:'办公室人群 - 工作压力 - 产品列表',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'场景护肤',reportEvent_third_module:'办公室人群'})),show_oth_pro=true,office_layer_check_type='oil_control'">控油产品推荐</span></div>
                    </div>
                    <!-- 精简护肤 -->
                    <div class="office_item">
                        <div class="office_item_title"><span class="office_item_title_text">舒缓抗炎</span></div>
                        <p class="office_item_text">如果皮肤有敏感的情况，容易泛红、灼热、瘙痒等，建议使用敏感肌专用、具有舒缓抗炎功能的护肤品，帮助镇静皮肤，缓解炎症带来的不适感。</p>
                        <!-- <div class="office_item_summary">清洁力需求:较高</div>
                        <div class="office_item_summary">清洁产品种类推荐:卸妆油，卸妆膏</div> -->
                        <div class="office_item_check_btn"><span @click="($parent.trackLog((actParams = { query: $route.query, pageid:621 }),{is_access:true,reportEvent_page_id:621,reportEvent_page_name:'办公室人群 - 工作压力 - 产品列表',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'场景护肤',reportEvent_third_module:'办公室人群'})),show_oth_pro=true,office_layer_check_type='sensitive'">舒缓产品推荐</span></div>
                    </div>
                    <!-- 祛痘 -->
                    <div class="office_item">
                        <div class="office_item_title"><span class="office_item_title_text">修复屏障</span> <span class="office_item_title_mark">特殊</span></div>
                        <p class="office_item_text">压力之下皮肤自身的屏障修复能力下降，此时建议使用修复型乳霜，为皮肤补充神经酰胺等成分，加强保湿，防止屏障变差。</p>
                        <!-- <div class="office_item_summary">清洁力需求:较高</div>
                        <div class="office_item_summary">清洁产品种类推荐:眼唇卸妆液</div> -->
                        <div class="office_item_check_btn"><span @click="($parent.trackLog((actParams = { query: $route.query, pageid:621 }),{is_access:true,reportEvent_page_id:621,reportEvent_page_name:'办公室人群 - 工作压力 - 产品列表',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'场景护肤',reportEvent_third_module:'办公室人群'})),show_oth_pro=true,office_layer_check_type='repair'">修复产品推荐</span></div>
                    </div>

                 

                </div>

                <!-- 更多建议 -->
                <div class="inner_down inner_down_third" v-if="focused_idx == 2">
                  <div class="office_more_sug">
                    <img src="../assets/images/office_sit_long.png" class="office_more_sug_pic" alt="">
                    <div class="office_more_sug_info">
                      <div class="office_more_sug_info_title">避免久坐不动</div>
                      <p class="office_more_sug_info_text">时常站起来活动一下，做一些可以在办公室完成的拉伸和肌肉训练。另外，坐姿要端正，可以放一个舒服的腰垫，给腰椎减轻压力。</p>
                    </div>
                  </div>
                  <div class="office_more_sug">
                    <img src="../assets/images/office_exercise.png" class="office_more_sug_pic" alt="">
                    <div class="office_more_sug_info">
                      <div class="office_more_sug_info_title">一周运动2~3次</div>
                      <p class="office_more_sug_info_text">运动可以刺激大脑中多巴胺的分泌，多巴胺能带给人快乐的情绪，帮助释放工作压力，同时也能增强体质。</p>
                    </div>
                  </div>
                  <div class="office_more_sug">
                    <img src="../assets/images/office_pressure.png" class="office_more_sug_pic" alt="">
                    <div class="office_more_sug_info">
                      <div class="office_more_sug_info_title">压力还会引起皮肤衰老</div>
                      <p class="office_more_sug_info_text">长期的压力会加速皮肤胶原蛋白的流失、引起更多自由基的产生，导致皮肤衰老加速。</p>
                    </div>
                  </div>
                  <div class="office_more_sug">
                    <img src="../assets/images/office_tired.png" class="office_more_sug_pic" alt="">
                    <div class="office_more_sug_info">
                      <div class="office_more_sug_info_title">警惕过劳肥和过劳秃</div>
                      <p class="office_more_sug_info_text">由心理压力引发的体内应激反应，和长期缺乏运动的生活习惯，会引起肥胖、脱发等问题，这是身体在亮红灯，一定要重视。</p>
                    </div>
                  </div>
           
                </div>

                    <!-- 其他产品列表弹窗 -->
                    <transition name="fade">
                        <div class="oth_rec_layer" v-if="show_oth_pro">
                            <div class="layer_inner">
                                <img src="../assets/images/close_btn.svg" class="close_icon" alt="" @click="show_oth_pro =false">
                                <div class="layer_title">{{office_layer_check_type=='water_maintain_spray'?'补水保湿-喷雾':office_layer_check_type=='water_maintain_lotion'?'补水保湿-乳液':office_layer_check_type=='oil_control'?'控油产品':office_layer_check_type=='sensitive'?'舒缓产品':office_layer_check_type=='repair'?'修复产品':''}}</div>
                                <ul class="layer_pro_list">
                                <li class="layer_pro" v-for="(oth_pro,oth_idx) in office_pro_list[office_layer_check_type]" :key="oth_idx">
                                    <div class="layer_pro_check_btn" v-if="oth_pro.go_mall" @click="$parent.goMallDetail(oth_pro.pro_id)">
                                        <span>去购买</span>
                                        <img src="../assets/images/arrow_right_d.svg" class="layer_pro_check_icon" alt="">
                                    </div>
                                    <img v-lazy="oth_pro.url" :key="oth_pro.url" class="pro_pic" alt="">
                                    <div class="pro_detail">
                                        <div class="pro_name">{{oth_pro.name}}</div>
                                        <div class="pro_ing" v-if="oth_pro.effect.length>0"><span>功效:</span><span class="ing_item">{{oth_pro.effect}}</span></div>
                                        <div class="pro_price">参考价格:<span>{{oth_pro.price}}</span></div>
                                    </div>
                                  
                                </li>
                                </ul>

                            </div>
                        </div>
                    </transition>

		
		</div>

 
	</div>
</template>

<script>
import Loading from "./Loading.vue";
import axios from "axios";
var wx = require("weixin-js-sdk");
export default {
  name: "ScenarioOffice",
  data() {
    return {
      isload: true,
      focused_idx:0,
      focused_left:0,
      focused_width:0,
      triangle_left:30,  //成分详情icon
      in_weapp: false, //是否在小程序
      officedata:null,
      show_office_remover:false,  //卸妆产品介绍弹窗
      show_reclean:false,  //二次清洁弹窗
      show_prevent_acne:false,  //预防致痘
      show_layer:false,
      show_oth_pro:false,
      office_layer_check_type:"",  //产品弹窗查看类型
      office_pro_type:"water_maintain_spray",   //办公室产品筛选类型
      office_pro_list:{
        water_maintain_spray:[
          {
            name:"理肤泉 舒缓调理喷雾",
            effect:"",
            price:"185元/300ml",
            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Travel_larocheposay_thermal_spring_water.png"
          },
          {
            name:"雅漾 舒护活泉水喷雾",
            effect:"",
            price:"186元/300ml",
            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Travel_avene_spray.png"
          },
          {
            name:"欧缇丽 葡萄活性保湿喷雾",
            effect:"",
            price:"130元/200ml",
            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Travel_caudalie_spray.png"
          },
          {
            name:"海蓝之谜 调理舒缓喷雾",
            effect:"",
            price:"650元/100ml",
            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Travel_lamer_spray.png"
          },
          {
            name:"依泉 舒缓保湿喷雾",
            effect:"",
            price:"168元/300ml",
            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Travel_uriage_eau_thermale_spray.png"
          },
          {
            name:"薇诺娜 马齿苋舒缓保湿喷雾",
            effect:"",
            price:"198元/150ml",
            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Travel_winona_spray.png"
          },
          {
            name:"依云 天然矿泉喷雾",
            effect:"",
            price:"150元/600ml",
            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Travel_evian_facial_spray.png"
          },
          {
            name:"薇姿 矿物赋能温泉水",
            effect:"",
            price:"118元/150ml",
            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Travel_vichy_facial_spray.png"
          }
        ],
        water_maintain_lotion:[
          {
            name:"优能平衡乳",
            effect:"",
            price:"239元/100g",
            go_mall:true,
            pro_id:14,
            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Lotion.png"
          },
          {
            name:"CeraVe 修护保湿润肤乳",
            effect:"",
            price:"178元/473ml",
            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Travel_cerave_moisturising_lotion_lati_hydratant.png"
          },
          {
            name:"理肤泉 特安舒缓修护乳",
            effect:"",
            price:"285元/40ml",
            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Travel_larocheposay_toleriane_ultra_light_intense_soothing_fluid.png"
          },
          {
            name:"DERMAPLAN AUS DEM MEDICO PALAIS JA乳液150ml清爽型",
            effect:"",
            price:"599元/150ml",
            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Travel_dermaplan_juckreiz_akut_pflege_lotion.png"
          },
          {
            name:"芙丽芳丝 保湿修护清爽乳液",
            effect:"",
            price:"230元/100ml",
            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Travel_freeplus_moist_care_emulsion.png"
          }
        ],
        oil_control:[
          {
            name:"优时颜净能控油精萃乳",
            effect:"",
            price:"180元/30g",
            go_mall:true,
            pro_id:19,
            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/PIPAR_1.png"
          },
          {
            name:"理肤泉 清痘净肤焕肤精华乳K+",
            effect:"",
            price:"278元/40ml",
            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Travel_larocheposay_effaclar_anti_acne_clearing_k_lotion.png"
          },
          {
            name:"ISDIN 控油净颜平衡日用乳",
            effect:"",
            price:"229元/50ml",
            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Travel_isdin_oil_free_everclean_oil_control_lotion.png"
          },
          {
            name:"Olay 5%烟酰胺小白瓶",
            effect:"",
            price:"280元/30ml",
            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Travel_olay_white_radiance_light_perfecting_essence.png"
          },
          {
            name:"The ordinary 10%烟酰胺精华",
            effect:"",
            price:"85元/30ml",
            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Travel_the_ordinary_yanxianan.png"
          },
          {
            name:"SK-II 肌因光蕴环采钻白精华露",
            effect:"",
            price:"2080元/60ml",
            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Travel_sk2_genoptics_aura_essence.png"
          }
        ],
        sensitive:[
          {
            name:"朵梵 多效舒缓精华液",
            effect:"",
            price:"680元/50ml",
            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Travel_darphin_intral_redness_relief_soothing_serum.png"
          },
          {
            name:"noreva 敏感肌抗红面霜 AR",
            effect:"",
            price:"680元/50ml",
            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Travel_noreva_sensidiane_soin_anti_rougeurs_anti_redness_care.png"
          },
          {
            name:"REN 抗敏舒缓精华",
            effect:"",
            price:"280元/30ml",
            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Travel_ren_evercalm_anti_redness_anti_rougeurs.png"
          },
          {
            name:"玉泽 皮肤屏障修护精华乳",
            effect:"",
            price:"336元/50ml",
            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Travel_dr_yu_skin_barrier_recovery_lotion.png"
          },
          {
            name:"薇诺娜 舒敏保湿修红霜",
            effect:"",
            price:"268元/50g",
            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Travel_winona_natural_skincare_anti_sensitive.png"
          }
        ],
        repair:[
          {
            name:"优时颜优能平衡乳",
            effect:"",
            price:"239元/100g",
            go_mall:true,
            pro_id:14,
            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Lotion.png"
          },
          {
            name:"优时颜优能平衡霜",
            effect:"",
            price:"320元/50g",
            go_mall:true,
            pro_id:13,
            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Cream.png"
          },
          {
            name:"珂润 润浸保湿滋养乳霜",
            effect:"",
            price:"188元/40g",
            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Travel_curel_intensive_moisture_cream.png"
          },
          {
            name:"CeraVe 修护保湿润肤乳",
            effect:"",
            price:"128元/236ml",
            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Travel_cerave_moisturising_lotion_lait_hydratant.png"
          },
          {
            name:"ISDIN 安肤舒缓滋润面霜",
            effect:"",
            price:"198元/50ml",
            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Travel_isdin_nutratopic_facial_cream_repair.png"
          },
          {
            name:"霏丝佳 特护修润霜",
            effect:"",
            price:"165元/50ml",
            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Travel_physiogel_hypoallergenic_calming_relief_cream.png"
          },
          {
            name:"玉泽 皮肤屏障修护保湿霜",
            effect:"",
            price:"198元/50g",
            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Travel_dr_yu_skin_barrier_recovery_cream.png"
          },
          {
            name:"玉泽 皮肤屏障修护调理乳",
            effect:"",
            price:"180元/50ml",
            url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Travel_dr_yu_skin_barrier_recovery_lotion.png"
          }
        ]

      }
    };
  },

  created() {
    console.log("scenariooffice created", this);
   
  },
  mounted() {
        setTimeout(() => {
			this.changeFocusedTab(this.focused_idx);
		}, 500);
      
    var ua = navigator.userAgent.toLowerCase(),
      that = this;
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          console.log("在小程序里");
          that.in_weapp = true;
        }
      });
    }
  },
  methods: {

    changeFocusedTab: function(idx) {
			this.focused_idx = idx;
			console.log(271, this.$refs['focused_item_' + idx]);
      setTimeout(
        () => {
          // this.focused_width = this.$refs['focused_item_' + idx].clientWidth;
          this.focused_width = 30;
			    this.focused_left = this.$refs['focused_item_' + idx].offsetLeft;
        }
      )
		
		},
    goMallDetail: function(pid) {
      if (this.in_weapp) {
        wx.miniProgram.navigateTo({
          url: "/mall-detail/mall-detail?scene=" + pid
        });
      } else {
        location.href =
          "https://www.uniskin.com.cn/homepage/m/pro_detail.html?p=" + pid;
      }
    },

    initCleanserGuide: function() {
      let that = this;
      var local_cleanser_guide = JSON.parse(localStorage.getItem("local_cleanser_guide"));
      if (local_cleanser_guide) {
        afterCleanserGuide(local_cleanser_guide);
      } else {
        that
          .$jsonp(
            "https://www.uniskin.com.cn/reportv2/index/report199_ex1/getCleanserRecommendGoods",{recommend:that.recommend,cleanser:that.cleanser,essence:that.essence,risk:that.risk,soap_base:that.soap_base}
          )
          .then(json => {
            console.log(json);
            afterCleanserGuide(json);
            // localStorage.setItem("local_cleanser_guide",JSON.stringify(json));
          })
          .catch(err => {
            console.log(err);
            localStorage.clear();
            location.href =
              "https://www.uniskin.com.cn/mall/member/account/login";
          });
      }
      function afterCleanserGuide(guidedata) {
        if (guidedata.code == 0) {
          that.isload = true;
  

        }
      }
    },
    initActionLog: function(m, pageid) {
      if (m && pageid)
        return axios.get("/mall/member/reportV2/actionlog", {
          params: { m, pageid }
        });
    }
  },
  components: {
    Loading
  }
};
</script>
<style lang="less" scoped>
@import "../styles/mixin.less";
@import "../styles/reset.less";
//其他产品弹窗
.oth_rec_layer{
    position:fixed;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background:rgba(0,0,0,0.2);
    .layer_inner{
        position:absolute;
        top:50%;
        left:50%;
        transform:translate(-50%,-50%);
        width:690/50rem;
        height:1033/50rem;
        .border-radius(14/50rem);
        .shadow;
        background:@bg_c_l;
        box-sizing:border-box;
        padding:45/50rem 20/50rem 45/50rem 0;
        .close_icon{
            position:absolute;
            top:52/50rem;
            right:30/50rem;
            width:30/50rem;
            height:30/50rem;
        }
        .layer_title{
            padding:0 0 60/50rem 30/50rem;
            font-size:44/50rem;
            line-height:1em;
            font-weight:bold;
        }
    }
}
.layer_pro{
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-justify;
    position:relative;
    .layer_pro_check_icon{
        position:absolute;
        right:0;
        top:35%;
        transform:translateY(-50%);
        width:27/50rem;
        height:27/50rem;
    }
    .layer_pro_check_btn{
        position:absolute;
        right:0;
        top:35%;
        transform:translateY(-50%);
         z-index:999;
        width:14/50rem;
        height:27/50rem;
        .display_flex;
        .flex-wrap_nowrap;
        .justify-content_flex-end;
        span{
            .align-self_center;
            font-size:24/50rem;
            line-height:1em;
            color:@font-c-detail;
            padding-right:30/50rem;
            white-space:nowrap;
        }
        img{
            .align-self_center;
            width:27/50rem;
            height:27/50rem;
        }
    }
    .pro_pic,.pro_detail{
        .align-self_flex-start;
    }
    .pro_pic{
        width:163/50rem;
    }
    .pro_detail{
        padding:16/50rem 50/50rem 55/50rem 0;
        margin-bottom:29/50rem;
        width:494/50rem;
        // border-bottom:1px solid @font-c-detail;
        .border-bottom;
        .pro_name{
            font-size:30/50rem;
            line-height:1.1em;
            color:@font-c-3;
            padding-bottom:23/50rem;
        }
        .pro_ing{
            .display_flex;
            .justify-content_flex-start;
            span{
                .flex_0;
                font-size:24/50rem;
                line-height:1em;
                color:@font-c-9;
                &.ing_item{
                    padding-right:20/50rem;
                }
            }
            
        }
        .pro_price{
            padding-top:16/50rem;
            font-size:24/50rem;
            line-height:1em;
            color:@font-c-9;
        }
    }
}
.layer_pro_list{
    height:863/50rem;
    -webkit-overflow-y:scroll;
    overflow-y:scroll;
    box-sizing:border-box;
}
.layer_pro_list .layer_pro:last-child{
    .pro_detail{
        // border-bottom:1px solid transparent;
        .border-bottom-transparent;
    }
}

.guide_inner{
    background:@bg_c_m;
    padding:0 0 169/50rem;
}
.back_btn{
    position:fixed;
    top:0.6rem;
    left:0;
    width:2.36rem;
    height:1.08rem;
    z-index:888;
}
.inner_up{
    padding:106/50rem 30/50rem 0;
    background:@font-c-f;
    .shadow;
    .guide_title{
      position:relative;
        padding-bottom:86/50rem;
        font-size:44/50rem;
        font-weight:bold;
        line-height:1em;
        text-align:center;
        color:@font-c-3;

    }
    .detail_menu {
    position:relative;
    box-sizing: border-box;
    // .shadow;
    // padding: 81/50rem 30/50rem 0/50rem;
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-start;
    .menu_item {
      padding-bottom: 15/50rem;
      margin-right:50/50rem;
      .align-items_flex-end;
      .flex_0;
    //   width: 33.33%;
      font-size: 28/50rem;
      line-height: 1em;
      text-align: center;
      color: @font-c-3;
      border-bottom: 3px solid transparent;
      &.now {
        font-size: 34/50rem;
        font-weight: bold;
        color:@font-c-detail;
        // border-bottom: 3px solid #f099a6;
      }
    }
  }
    .bg_div{
    position:absolute;
    bottom:0;
    height:3px;
    width:60/50rem;
    background:#f099a6;
    -webkit-transition:left 0.5s;
    transition:left 0.5s;
    }
}
.inner_down{
    padding:58/50rem 30/50rem 147/50rem;
}
//工作压力
.inner_down_second{
    padding:58/50rem 30/50rem 147/50rem;
    .inner_down_text{
        padding-bottom:37/50rem;
        line-height:28/50rem;
        font-size:24/50rem;
        color:@font-c-3;
    }
    .office_item{
        .border-radius(14/50rem);
        .shadow;
        background:@bg_c_l;
        padding:43/50rem 30/50rem 26/50rem;
        margin-bottom:30/50rem;
        .office_item_title{
            padding-bottom:10/50rem;
            .display_flex;
            .flex-wrap_nowrap;
            .justify-content_flex-start;
            .office_item_title_text{
              .align-self_center;
                font-size:30/50rem;
                line-height:1.1em;
                color:@font-c-3;
                font-weight:bold;
                // .border-bottom;
                border-bottom:2px solid @font-c-detail;
            }
            .office_item_title_mark{
              .align-self_center;
              margin-left:14/50rem;
              padding:7/50rem 18/50rem;
              .border-radius(23/50rem);
              background:#ffb37e;
              color:@font-c-f;
              font-size:22/50rem;
              line-height:1em;
            }
        }
        .office_item_text{
          padding-bottom:16/50rem;
          font-size:24/50rem;
          line-height:30/50rem;
          color:@font-c-6;
        }
        .office_item_summary{
          position:relative;
          padding:0 0 16/50rem 40/50rem;
          font-size:24/50rem;
          line-height:1.2em;
          color:@font-c-detail;
          &::before{
            content:"";
            position:absolute;
            top:5/50rem;
            left:19/50rem;
            width:10px;
            height:10px;
            -webkit-transform:scale(0.5);
            transform:scale(0.5);
            .border-radius(50%);
            background:@font-c-0;

          }
        }
        .office_item_check_btn{
          padding-top:5/50rem;
          .display_flex;
          .flex-wrap_nowrap;
          .justify-content_flex-end;
          span{
            padding:12/50rem 30/50rem;
            text-align:center;
            font-size:24/50rem;
            line-height:1em;
            color:@font-c-3;
            .border-1px;
          }
        }
    }
  .office_focus_part{
    .border-radius(14/50rem);
    .shadow;
    .gradient(to right,#A5D6F0,#679BEF);
    padding:35/50rem 0 45/50rem;
    .office_focus_title{
      text-align:center;
      padding-bottom:21/50rem;
      font-size:34/50rem;
      line-height:1em;
      font-weight:bold;
      color:@font-c-f;
    }
    .office_focus{
      // padding-bottom:17/50rem;
      // padding-left:174/50rem;
      .display_flex;
      .flex-wrap_nowrap;
      .justify-content_flex-center;
      span{
        position:relative;
        .align-self_center;
        font-size:28/50rem;
        line-height:1em;
        color:@font-c-f;
        padding-left:20/50rem;
        padding-right:40/50rem;
          &::before{
          content:"";
          display:block;
          width:10px;
          height:10px;
          position:absolute;
          left:0;
          top:50%;
          .border-radius(50%);
          background:@font-c-f;
          -webkit-transform:translateY(-50%) scale(0.5);
          transform:translateY(-50%) scale(0.5);
          
        }
        &:last-child{
          padding-right:0;
        }
      }

    }
  }
  .office_skincare_sug_title{
    padding:48/50rem 0 28/50rem;
    font-size:30/50rem;
    line-height:1em;
    color:@font-c-3;
    font-weight:bold;
  }

  
}

//空调和暖气
.inner_down_first{
  padding:39/50rem 30/50rem 147/50rem;
  .inner_down_sub_text{
    padding-bottom:43/50rem;
    font-size:24/50rem;
    line-height:28/50rem;
    color:@font-c-3;
  }
  .office_focus_part{
    .border-radius(14/50rem);
    .shadow;
    .gradient(to right,#A5D6F0,#679BEF);
    padding:35/50rem 0 45/50rem;
    .office_focus_title{
      text-align:center;
      padding-bottom:21/50rem;
      font-size:34/50rem;
      line-height:1em;
      font-weight:bold;
      color:@font-c-f;
    }
    .office_focus{
      // padding-bottom:17/50rem;
      // padding-left:174/50rem;
      .display_flex;
      .flex-wrap_nowrap;
      .justify-content_flex-center;
      span{
        position:relative;
        .align-self_center;
        font-size:28/50rem;
        line-height:1em;
        color:@font-c-f;
        padding-left:20/50rem;
        padding-right:40/50rem;
          &::before{
          content:"";
          display:block;
          width:10px;
          height:10px;
          position:absolute;
          left:0;
          top:50%;
          .border-radius(50%);
          background:@font-c-f;
          -webkit-transform:translateY(-50%) scale(0.5);
          transform:translateY(-50%) scale(0.5);
          
        }
        &:last-child{
          padding-right:0;
        }
      }

    }
  }
  .office_skincare_title{
    padding:48/50rem 0 34/50rem;
    font-size:34/50rem;
    line-height:1em;
    font-weight:bold;
    color:@font-c-3;
  }
  .office_skincare_sug_title{
    padding-bottom:6/50rem;
    font-size:28/50rem;
    line-height:1em;
    font-weight:bold;
    color:@font-c-3;
  }
  .office_skincare_sug_text{
    padding-bottom:12/50rem;
    font-size:24/50rem;
    line-height:30/50rem;
    color:@font-c-6;
  }
  .office_skincare_sug_detail{
    margin-bottom:46/50rem;
    .shadow;
    .border-radius(14/50rem);
    background:#fcfcfc;
    padding:34/50rem 0 24/50rem 34/50rem;
    .office_skincare_sug_detail_item{
      padding-bottom:16/50rem;
      font-size:24/50rem;
      line-height:1em;
      color:@font-c-6;
      &:first-child{
        padding-bottom:18/50rem;
      }
    }
  }
  .office_rec_pro{
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-justify;
    position:relative;
    .office_rec_pro_check_btn{
        position:absolute;
        right:0;
        top:50%;
        transform:translateY(-50%);
        z-index:999;
        // width:27/50rem;
        // height:27/50rem;
        .display_flex;
        .flex-wrap_nowrap;
        .justify-content_flex-end;
        span{
            font-size:24/50rem;
            white-space:nowrap;
            line-height:1em;
            color:#f99d9b;
            .align-self_center;
        }
        .office_rec_pro_check_icon{
            margin-left:10/50rem;
            width:27/50rem;
            height:27/50rem;
            .align-self_center;
        }
    }
    .pro_pic,.pro_detail{
        .align-self_center;
    }
    .pro_pic{
        width:163/50rem;
    }
    .pro_detail{
        padding:51/50rem 50/50rem 44/50rem 0;
        // margin-bottom:29/50rem;
        width:494/50rem;
        // border-bottom:1px solid @font-c-detail;
        .border-bottom;
        .pro_name{
            font-size:30/50rem;
            line-height:1em;
            color:@font-c-3;
            padding-bottom:23/50rem;
        }
        .pro_ing{
            .display_flex;
            .justify-content_flex-start;
            .flex-wrap_wrap;
            span{
                .flex_0;
                font-size:24/50rem;
                line-height:1.1em;
                color:@font-c-9;
                &.ing_item{
                    padding-right:20/50rem;
                }
            }
            
        }
        .pro_price{
            padding-top:16/50rem;
            font-size:24/50rem;
            line-height:1em;
            color:@font-c-9;
        }
    }
  }
  .office_rec_pro_list{
    box-sizing:border-box;
    margin-bottom:147/50rem;
    padding-right:20/50rem;
    background:@bg_c_l;
    .border-radius(14/50rem);
    .shadow;
  }
  .office_rec_pro_list .office_rec_pro:last-child{
      .pro_detail{
          // border-bottom:1px solid transparent;
          .border-bottom-transparent;
      }
  }
  .office_rec_title{
    padding:0 0 28/50rem;
    font-size:28/50rem;
    line-height:1em;
    color:@font-c-3;
    font-weight:bold;
  }
  .office_filter_menu{
    padding-bottom:30/50rem;
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-start;
    .office_filter_menu_item{
      box-sizing:border-box;
      margin-right:30/50rem;
      font-size:28/50rem;
      line-height:1em;
      color:@font-c-detail;
      padding:13/50rem 28/50rem;
      .border-radius(34/50rem);
      // .border-1px-34;
      border:1px solid @font-c-detail;
      &.now{
        color:@font-c-f;
        background:@font-c-detail;

      }
    }
  }

}

//使用建议
.inner_down_third{
  padding:56/50rem 30/50rem 225/50rem;
  .office_more_sug{
    padding-bottom:40/50rem; 
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-justify;
    .office_more_sug_pic{
      width:140/50rem;
      height:140/50rem;
      .border-radius(14/50rem);
      .shadow;
      background:#fcfcfc;
    }
    .office_more_sug_info{
      padding-top:7/50rem;
      width:525/50rem;
      .office_more_sug_info_title{
        padding-bottom:11/50rem;
        font-size:30/50rem;
        line-height:1em;
        font-weight:bold;
        color:@font-c-3;
      }
      .office_more_sug_info_text{
        font-size:24/50rem;
        line-height:30/50rem;
        color:@font-c-6;
      }
    }
  }
}


</style>
